import { Component } from '@angular/core';
import { AdvertisingService } from '../advertising.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { EstimateService } from '../../poker-room/estimate.service';

/** Bare partner link until Ahouva confirms the PartnerStack sub-ID syntax
 *  (then append e.g. `?sid=results`) — see handover §4. */
const MONDAY_AFFILIATE_URL = 'https://try.monday.com/vf4kvzm1trvl';

/**
 * Disclosed monday.com affiliate text link, shown under the results table at
 * the moment a revealed estimate raises the "where do we track this?" question.
 * Replaces the rewarded-ad CTA in the UI (that component stays reactivatable);
 * see _scrumpoker-info/monetization/handover-monday-affiliate-cta-2026-08-24.md.
 *
 * Visibility (both must hold):
 *  - `showEstimates`: only while cards are revealed, so the link is tied to the
 *    result moment instead of standing around as session-long advertising.
 *  - `fuseAdsAllowed` (NOT `fuseAdsVisible`): premium rooms/viewers stay clean,
 *    but a running ad-free hour from the rewarded remnant only concerns display
 *    ads and must not suppress this link.
 *
 * The embedding site additionally keeps it out of the presentation dialog
 * (`isDialog` in results.component.html) — no ads on projected screens.
 */
@Component({
    selector: 'affiliate-cta',
    templateUrl: './affiliate-cta.component.html',
    styleUrls: ['./affiliate-cta.component.scss'],
})
export class AffiliateCtaComponent {
    readonly affiliateUrl = MONDAY_AFFILIATE_URL;

    constructor(
        public advertisingService: AdvertisingService,
        public estimateService: EstimateService,
        private googleAnalyticsService: GoogleAnalyticsService,
    ) {}

    get visible(): boolean {
        return this.estimateService.showEstimates && this.advertisingService.fuseAdsAllowed;
    }

    /** Fires synchronously before the browser follows the link; target=_blank
     *  keeps the page (and the gtag call) alive, so the event is not lost. */
    trackClick(): void {
        this.googleAnalyticsService.event('affiliate_click', {
            partner: 'monday',
            placement: 'results',
        });
    }
}
